<template>
  <v-stepper-step
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    color="accent"
  >
    <slot></slot>
  </v-stepper-step>
</template>

<script>
export default {
  name: "AvsStep"
}
</script>
